import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestGroupingDemo from './TestGroupingDemo'
import TestGroupingEditorActions from './TestGroupingEditorActions'
import TestGroupingElement from './TestGroupingElement'
import TestGroupingFormBrand from './TestGroupingFormBrand'
import { STYLE_FORM_SCHEMA } from './TestGroupingFormStyle'
import TestGroupingFormValue from './TestGroupingFormValue'
import testGroupingIcon from './assets/testGrouping.svg'

export default genElementConfig(CONFIG_ELEMENTS.testGrouping, {
  label: t('elements.testGrouping.label'),
  icon: testGroupingIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestGroupingElement,
  Demo: [TestGroupingDemo],
  FormValue: TestGroupingFormValue,
  FormBrand: TestGroupingFormBrand,
  EditorActions: TestGroupingEditorActions,
})
